<div class="pf-eyebrow">Antes de começar</div>
<div class="pf-titulo">
  <span class="onb-ic onb-ic--loja"><i class="fas fa-store" aria-hidden="true"></i></span>
  <h1>Conhecendo seu negócio</h1>
</div>
<p class="onb-sub">Duas perguntas rápidas. Com elas a gente ajusta o horário e as sugestões para o seu tipo de loja.</p>

<div class="onb-grupo-rot"><span id="onb-perfil-tipo-rot">Qual o tipo de comida principal?</span></div>
<div class="pf-tipos" id="onb-perfil-tipo" role="radiogroup" aria-labelledby="onb-perfil-tipo-rot">
  <button type="button" class="pf-chip" *ngFor="let t of tipos" role="radio" [attr.aria-checked]="tipo === t.id"
          [class.ativo]="tipo === t.id" (click)="escolhaTipo(t.id)">
    <i [class]="t.icone" aria-hidden="true"></i>{{ t.nome }}
  </button>
</div>
<div class="onb-campo pf-outro" *ngIf="tipo === 'OUTRO'">
  <label for="onb-perfil-outro">Qual?</label>
  <input class="onb-inp" id="onb-perfil-outro" [(ngModel)]="outro" maxlength="80" placeholder="Ex.: tapiocaria">
</div>

<div class="onb-grupo-rot pf-rot-faixa"><span id="onb-perfil-faixa-rot">Quanto seu delivery vendeu no mês passado?</span></div>
<p class="pf-dica">Somando tudo: WhatsApp, telefone, iFood e outros aplicativos. Um valor aproximado já serve.</p>
<div class="pf-faixas" id="onb-perfil-faixa" role="radiogroup" aria-labelledby="onb-perfil-faixa-rot">
  <button type="button" class="pf-faixa" *ngFor="let f of faixas" role="radio" [attr.aria-checked]="faixa === f.id"
          [class.ativo]="faixa === f.id" (click)="faixa = f.id">{{ f.nome }}</button>
</div>
<p class="pf-privado"><i class="fas fa-lock" aria-hidden="true"></i> Fica só com a equipe do MeuCardápio. Não aparece na sua loja.</p>

<div class="onb-erro" *ngIf="erro">{{ erro }}</div>

<div class="onb-rodape">
  <span class="onb-dica"></span>
  <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="salve()">
    {{ salvando ? 'Salvando…' : 'Continuar' }} <i class="fas fa-arrow-right" aria-hidden="true" *ngIf="!salvando"></i>
  </button>
</div>
